import Vue from 'vue'
function getWxConfig () {
    this.$http.get("http://hnjsdb.com/api/wechat/jsConfig.json?callback=_onWeChatAPIReady&url=" + encodeURIComponent(window.location.href)).then(({
        data
    }) => {
        console.log(data)
        return wx.config(data);
    })
}

export default {
    getWxConfig
}


// WEBPACK FOOTER //
// ./src/util/getWxConfig.js